import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import ContainerCard from "@/components/layout/CardContainer.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordForm',
  props: {
  logo: {
    type: String,
    required: false,
  },
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  success: {
    type: Boolean,
    default: false,
  },
},
  emits: ["goto-login", "submit"],
  setup(__props, { emit }) {

const props = __props





const form = ref({
  email: "",
})

const observer = ref(null)

const resetForm = () => {
  form.value.email = ""
  observer && (observer.value as any).reset()
}

const onResetPassword = () => {
  if (!form.value.email) return
  emit("submit", form.value.email, resetForm)
}

return { __sfc: true,emit, props, form, observer, resetForm, onResetPassword, ContainerCard }
}

})